import { useTranslation } from 'react-i18next';
import { ChangeEvent, useRef } from 'react';
import { Select } from '../../../../ui/Select';
import { SORTING_VARIANTS } from '../../../../../utils/helpers/constants';
import {
  SortingContainer,
  SelectedValueContainer,
  borderedSortingStyles
} from '../styled';
import { SelectHorizontalAlignmentEnum } from '../../../../ui/Select/types';
import { NewRadioButton } from '../../../../NewRadioButton';
import { SelectRefType } from '../../types';
import { SortIcon } from '../../../../../icons/Sort';
import { ItemConnectionSort } from '../../../../../graphql/types';
import useScreenSize from '../../../../../hooks/useScreenSize';
import { modalStyles } from '../../../../Residences/ResidencesSorting/styled';
import { useClient } from '../../../../../hooks/useClient';

interface ItemsSortingFilterProps {
  currentSortValue: string;
  submitOnChange?: boolean;
  showIcon: boolean;
  disabled?: boolean;
  dataStat: string;
  onChange: (sortValue: ItemConnectionSort) => void;
}

export const ItemsSortingFilter: React.FC<ItemsSortingFilterProps> = ({
  currentSortValue,
  submitOnChange = false,
  showIcon = true,
  disabled = false,
  dataStat,
  onChange
}) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();
  const isClient = useClient();
  const selectRef = useRef<SelectRefType>(null);

  const value = SORTING_VARIANTS.find(
    variant => variant.id === currentSortValue
  );

  const selectedValue = (
    <SelectedValueContainer>
      <SortIcon />
      {(!isSmall && isClient) || !isClient ? t(value?.name || '') : ''}
    </SelectedValueContainer>
  );

  const onChangeRadioHandler = (event?: ChangeEvent<HTMLInputElement>) => {
    if (!event) return;

    onChange(event.target.value as ItemConnectionSort);

    if (submitOnChange && selectRef.current) {
      selectRef.current.closePopover();
    }
  };

  return (
    <Select
      ref={selectRef}
      placeholder={t('search.buttons.sort')}
      value={selectedValue}
      cypress={`${dataStat}-sorting-modal`}
      stat={`${dataStat}-sorting-modal`}
      horizontalAlign={SelectHorizontalAlignmentEnum.Right}
      width={251}
      modalTitle={t('search.buttons.sort')}
      styles={borderedSortingStyles}
      modalCypress="filter-modal"
      showIcon={showIcon}
      stylesModal={modalStyles}
      ariaLabel="Sort"
      disabled={disabled}
    >
      <SortingContainer>
        {SORTING_VARIANTS.map(sorting => (
          <NewRadioButton
            data={{ ...sorting, name: t(sorting.name) }}
            key={sorting.id}
            cypress="sorting"
            stat={sorting.stat}
            name="sorting"
            currentValue={currentSortValue}
            onChangeHandler={onChangeRadioHandler}
          />
        ))}
      </SortingContainer>
    </Select>
  );
};
